module.exports = __webpack_public_path__ + "assets/img/16_1818.bd060d35.jpg";